export const levelColorsList = [
  '#F97474',
  '#FBB9A6',
  '#FEBA65',
  '#F3D260',
  '#FFEA06',
  '#E6EB00',
  '#47E1DC',
  '#5AE9B1',
  '#70EB5A'
];

export const LEVEL_HEIGHT = '40px';
export const MAX_LEVEL_GUARD_PERCENTAGE = 75;
export const MIN_LEVEL_GUARD_PERCENTAGE = 25;
export const MIN_LEVEL = 1;

export const levelConstructList = [
  {
    level: 1,
    levelLowerLimit: 25676.6,
    levelUpperLimit: 554464.91
  },
  {
    level: 2,
    levelLowerLimit: 555717.36,
    levelUpperLimit: 876699.78
  },
  {
    level: 3,
    levelLowerLimit: 882595.22,
    levelUpperLimit: 993750.74
  },
  {
    level: 4,
    levelLowerLimit: 994443.69,
    levelUpperLimit: 1094499.45
  },
  {
    level: 5,
    levelLowerLimit: 1098591.56,
    levelUpperLimit: 1187158.21
  },
  {
    level: 6,
    levelLowerLimit: 1187421.42,
    levelUpperLimit: 1301905.05
  },
  {
    level: 7,
    levelLowerLimit: 1302165.74,
    levelUpperLimit: 1923532.05
  },
  {
    level: 8,
    levelLowerLimit: 1923532.74,
    levelUpperLimit: 3223532.05
  },
  {
    level: 9,
    levelLowerLimit: 3223532.74,
    levelUpperLimit: 5223532.05
  }
];

export interface levelConstructListType {
  level: number;
  levelLowerLimit: number;
  levelUpperLimit: number;
  color: string;
}

export interface levelConstructListBEType {
  level: number;
  levelLowerLimit: number;
  levelUpperLimit: number;
}
